export default __webpack_public_path__ + "static/media/image-header-3.4f4a9945.png";